import React from 'react';
import { _T, C } from '../../../shared/theme';
import { s_GC } from '../../../shared/styles';
import { EXERCISE_GROWTH_MAP, GROWTH_XP_LABELS, GROWTH_XP_LABELS_EN, GROWTH_XP_BARS } from '../constants';
import { GROWTH_CATEGORIES } from '../../goals/constants';

function GrowthEffects({exerciseId, lang, compact=false}) {
  const nl = lang==="nl";
  const contribs = EXERCISE_GROWTH_MAP[exerciseId] || {};
  const entries = Object.entries(contribs).sort((a,b)=>b[1]-a[1]);
  if (!entries.length) return null;

  if (compact) {
    return (
      <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:4}}>
        {entries.map(([catId,xp])=>{
          const cat = GROWTH_CATEGORIES.find(c=>c.id===catId);
          if (!cat) return null;
          return (
            <div key={catId} style={{display:"flex",alignItems:"center",gap:3,background:`${cat.color}15`,border:`1px solid ${cat.color}33`,borderRadius:20,padding:"2px 8px"}}>
              <span style={{fontSize:13}}>{cat.icon}</span>
              <span style={{fontSize:9,color:cat.color,fontWeight:600}}>{"●".repeat(xp)+"○".repeat(3-xp)}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div style={s_GC({marginBottom:14})}>
      <div style={{fontSize:13,color:_T.accent,letterSpacing:3,fontWeight:600,marginBottom:10}}>
        🕸️ {nl?"GROEI-EFFECT":"GROWTH EFFECT"}
      </div>
      {entries.map(([catId,xp])=>{
        const cat = GROWTH_CATEGORIES.find(c=>c.id===catId);
        if (!cat) return null;
        return (
          <div key={catId} style={{marginBottom:10}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontSize:16}}>{cat.icon}</span>
                <span style={{color:cat.color,fontSize:12,fontWeight:600}}>{nl?cat.label:cat.labelEN}</span>
              </div>
              <span style={{fontSize:13,color:cat.color,fontWeight:600}}>
                {nl?GROWTH_XP_LABELS[xp]:GROWTH_XP_LABELS_EN[xp]}
              </span>
            </div>
            <div style={{height:5,background:_T.bg4,borderRadius:3,overflow:"hidden"}}>
              <div style={{width:`${(xp/3)*100}%`,height:"100%",background:`linear-gradient(90deg,${cat.color}66,${cat.color})`,borderRadius:3}}/>
            </div>
          </div>
        );
      })}
      <div style={{fontSize:13,color:C.silver,marginTop:6,lineHeight:1.5}}>
        {nl?"Groot effect telt 1.5x mee voor jouw level-up voortgang.":"Large effect counts 1.5x toward your level-up progress."}
      </div>
    </div>
  );
}

export default GrowthEffects;
